import React, { useEffect } from "react";
import MuiAlert from "@mui/material/Alert";

export default function Warning({
  isWarning,
  setIsWarning,
  severity,
  message,
}) {
  useEffect(() => {
    setTimeout(() => {
      if (!setIsWarning) {
        isWarning = {
          open: false,
        };
      } else {
        setIsWarning({
          open: false,
        });
      }
    }, 5000);
  }, []);

  return (
    <>
      {isWarning && (
        <MuiAlert
          variant="filled"
          severity={severity}
          className="fixed-bottom"
          sx={{
            width: "40%",
            bottom: 75,
            left: 50,
          }}
        >
          {message}
        </MuiAlert>
      )}
    </>
  );
}
